// import React, { useState } from 'react';

import React, { useState, useRef } from 'react';
import {
    Box,
    Typography,
    Avatar,
    TextField,
    IconButton,
    MenuItem,
    Paper,
    InputAdornment,
    Popper,
    ClickAwayListener,
    Select,
    Checkbox,
    FormControl,
} from '@mui/material';
import SearchIcon from '@mui/icons-material/Search';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import { CloseBlackIcon } from '../../../icons';


const projects = [
    { id: 1, name: 'Project Quantum', adminSel:'Admin', image: '', code: 'PQ', description: 'Description 1' },
    { id: 2, name: 'Digital Marketing', adminSel: null, image: '', code: 'DM', description: 'Description 2' },
    { id: 3, name: 'SkyGrid', adminSel:null, image: '', code: 'SG', description: 'Description 3' },
    { id: 4, name: 'Video Editor', adminSel:null, image: '', code: 'VE', description: 'Description 4' },
    { id: 5, name: 'Digital Marketing', adminSel:null, image: '', code: 'DM', description: 'Description 5' },
    { id: 6, name: 'SkyGrid', adminSel:null, image: '', code: 'SG', description: 'Description 6' },
    { id: 7, name: 'Video Editor', adminSel:null, image: '', code: 'VE', description: 'Description 7' },
];

const getInitials = (name) => {
    const words = name.split(' ');
    return words.length > 1
        ? words[0][0].toUpperCase() + words[1][0].toUpperCase()
        : name.slice(0, 2).toUpperCase();
};


const SingleSelectSetOwner = ({ selectedProject, setSelectedProject }) => {

    const [search, setSearch] = useState('');
    const [dropdownOpen, setDropdownOpen] = useState(false);
    const anchorRef = useRef(null);

    const filteredProjects = projects.filter((p) =>
        p.name.toLowerCase().includes(search.toLowerCase())
    );

    const [selectedProjects, setSelectedProjects] = useState([]);

    const handleProjectSelect = (project) => {
        const alreadySelected = selectedProjects.some((p) => p.id === project.id);
        setSelectedProjects((prev) =>
            alreadySelected ? prev.filter((p) => p.id !== project.id) : [...prev, project]
        );
    };


    return (
        <>
            {/* Project Dropdown */}
            <Box mb={2}>
                <ClickAwayListener onClickAway={() => setDropdownOpen(false)}>
                    <div>
                        {/* <Typography fontWeight={500} mb={'6px'} sx={{ fontSize: '14px', fontWeight: '600', color: '#1A1F36' }}>Project*</Typography> */}
                        <TextField
                            fullWidth
                            placeholder="Select Project"
                            inputRef={anchorRef}
                            value={selectedProject?.name || ''}
                            onClick={() => setDropdownOpen(!dropdownOpen)}
                            InputProps={{
                                readOnly: true,
                                endAdornment: (
                                    <InputAdornment position="end">
                                        <ArrowDropDownIcon />
                                    </InputAdornment>
                                ),
                            }}
                            sx={{
                                height: '40px',
                                fontFamily:'Manrope',
                                '& .MuiOutlinedInput-root': {
                                    height: '40px',
                                    borderRadius: '8px',
                                    fontSize: '14px',
                                    fontWeight: 400,
                                    border: '1px solid #D0D5DD',
                                    paddingRight: 1,
                                    color: '#64748B',
                                    fontFamily:'Manrope'
                                },
                                '& .MuiOutlinedInput-notchedOutline': {
                                    border: 'none', // removes double border from default outline
                                    fontFamily:'Manrope'
                                },
                            }}
                        />

                        <Popper
                            open={dropdownOpen}
                            anchorEl={anchorRef.current}
                            style={{ zIndex: 1300, width: anchorRef.current?.offsetWidth,fontFamily:'Manrope' }}
                        >
                            <Paper sx={{ mt: 1, maxHeight: 250, overflowY: 'auto' }}>
                                <Box p={1} sx={{ position: 'sticky', top: '0', zIndex: '9', background: '#fff', }}>
                                    <TextField
                                        placeholder="Search Project"
                                        value={search}
                                        onChange={(e) => setSearch(e.target.value)}
                                        fullWidth
                                        size="small"
                                        InputProps={{
                                            startAdornment: (
                                                <InputAdornment position="start">
                                                    <SearchIcon fontSize="small" />
                                                </InputAdornment>
                                            ),
                                        }}
                                        sx={{
                                            fontFamily:'Manrope',
                                            '& .MuiOutlinedInput-root': {
                                                borderRadius: '100px',
                                                fontFamily:'Manrope',
                                            },
                                        }}
                                    />
                                </Box>
                                
                                {filteredProjects.map((project) => (
                                    <MenuItem key={project.id} onClick={() => handleProjectSelect(project)}>
                                        <Checkbox
                                            checked={selectedProjects.some((p) => p.id === project.id)}
                                            icon={
                                                <Box
                                                    sx={{
                                                        width: 24,
                                                        height: 24,
                                                        borderRadius: '4px',
                                                        border: '1px solid #D0D5DD',
                                                        backgroundColor: '#E5E8EB',
                                                        display: 'flex',
                                                        alignItems: 'center',
                                                        justifyContent: 'center',
                                                    }}
                                                >
                                                    <svg width="18" height="18" viewBox="0 0 24 24" fill="none">
                                                        <defs>
                                                            <filter id="shadow" x="-50%" y="-50%" width="200%" height="200%">
                                                                <feDropShadow
                                                                    dx="0"
                                                                    dy="1"
                                                                    stdDeviation="1"
                                                                    floodColor="black"
                                                                    floodOpacity="0.4"
                                                                />
                                                            </filter>
                                                        </defs>
                                                        <path
                                                            d="M20 6L9 17L4 12"
                                                            stroke="white"
                                                            strokeWidth="3"
                                                            strokeLinecap="round"
                                                            strokeLinejoin="round"
                                                            filter="url(#shadow)"
                                                        />
                                                    </svg>
                                                </Box>
                                            }
                                            checkedIcon={
                                                <Box
                                                    sx={{
                                                        width: 24,
                                                        height: 24,
                                                        borderRadius: '4px',
                                                        backgroundColor: '#1976d2',
                                                        display: 'flex',
                                                        alignItems: 'center',
                                                        justifyContent: 'center',
                                                    }}
                                                >
                                                    <svg width="18" height="18" viewBox="0 0 24 24" fill="none">
                                                        <path
                                                            d="M20 6L9 17L4 12"
                                                            stroke="white"
                                                            strokeWidth="3"
                                                            strokeLinecap="round"
                                                            strokeLinejoin="round"
                                                        />
                                                    </svg>
                                                </Box>
                                            }
                                        />
                                        <Avatar
                                            src={project.image}
                                            sx={{
                                                width: 32,
                                                height: 32,
                                                mr: 2,
                                                fontSize: '14px',
                                                background: '#0067C7',
                                                fontFamily:'Manrope',
                                            }}
                                        >
                                            {!project.image && getInitials(project.name)}
                                        </Avatar>
                                        <Typography sx={{fontFamily:'Manrope'}}>{project.name}</Typography>
                                    </MenuItem>
                                ))}

                            </Paper>
                        </Popper>
                    </div>
                </ClickAwayListener>
            </Box>

            {/* Selected project display */}

            {selectedProjects.length > 0 && selectedProjects.map((proj) => (
                <Box
                    key={proj.id}
                    mb={1}
                    p={1}
                    border="1px solid #DFDFDF"
                    borderRadius={100}
                    display="flex"
                    alignItems="center"
                    justifyContent="space-between"
                    sx={{
                        background: '#F6F6F6',
                        height: '50px',
                        fontFamily:'Manrope'
                    }}
                >
                    <Box display="flex" alignItems="center" gap={1}>
                        <Avatar
                            src={proj.image}
                            sx={{ fontSize: '14px', background: '#0067C7', width: '34px', height: '34px', fontFamily:'Manrope' }}
                        >
                            {!proj.image && getInitials(proj.name)}
                        </Avatar>
                        <Box>
                            <Typography display="flex" alignItems="center" sx={{gap:'20px', color: '#373737', fontSize: '14px', fontWeight: '600', fontFamily:'Manrope' }}>{proj.name} 
                                <span style={{color: '#0076FE', fontSize:'12px', fontWeight:'500',fontFamily:'Manrope', backgroundColor:'#0076FE26', padding:' 0 8px' ,borderRadius:'100px'}}>
                                    {proj.adminSel}</span></Typography>
                            <Typography sx={{ color: '#9095A1', fontSize: '10px', fontFamily:'Manrope' }}>
                                {proj.description}
                            </Typography>
                        </Box>
                    </Box>
                    <Box display="flex" alignItems="center" gap={1}>
                        <FormControl>
                            <Select
                                defaultValue=""
                                displayEmpty
                                sx={{
                                    fontSize: '14px',
                                    border: 'none',
                                    fontFamily:'Manrope',
                                    '& .MuiSelect-select': { padding: '0', border: 'none', fontFamily:'Manrope' },
                                    '& .MuiOutlinedInput-notchedOutline': { border: 'none', fontFamily:'Manrope' },
                                }}
                            >
                                <MenuItem sx={{fontFamily:'Manrope'}} disabled value="">User</MenuItem>
                                <MenuItem sx={{fontFamily:'Manrope'}} value="Owner">Owner</MenuItem>
                                <MenuItem sx={{fontFamily:'Manrope'}} value="Manager">Manager</MenuItem>
                                <MenuItem sx={{fontFamily:'Manrope'}} value="Viewer">Viewer</MenuItem>
                                <MenuItem sx={{fontFamily:'Manrope'}} value="User">User</MenuItem>
                            </Select>
                        </FormControl>

                        <IconButton onClick={() =>
                            setSelectedProjects((prev) => prev.filter((p) => p.id !== proj.id))
                        }>
                            <CloseBlackIcon />
                        </IconButton>
                    </Box>
                </Box>
            ))}

        </>
    );
}

export default SingleSelectSetOwner;
